import { render, staticRenderFns } from "./TextInput.vue?vue&type=template&id=363fa2d4"
import script from "./TextInput.ts?vue&type=script&lang=ts&external"
export * from "./TextInput.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports